import { Color } from '@billy/design-system'
import { transparentize } from 'polished'

export const FORMS_INNER_SHADOW = `inset 0 2px 4px ${transparentize(0.7, Color.Grey300)}`
